import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Autocomplete,
} from "@mui/material";

import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import AddCircleIcon from "@mui/icons-material/AddCircle";

import { useNavigate } from "react-router-dom";
import {
  CustomAutoComplete,
  CustomInputField,
  CustomTextArea,
} from "../CommonComponents/CustomCompontes";
import { MultiSelect } from "react-multi-select-component";
import TopViewNav from "../CommonComponents/TopViewNav";
import moment from "moment";
import { dynamiceForm } from "../../actions/DynamiceForm";
import { companyWiseEmp } from "../../actions/Companywiseclient";
import ImportExcel from "./ImportExcel/ImportExcel";

const getInputDefaultVal = (type) => {
  if (
    type === "Text" ||
    type === "Email" ||
    type === "TextArea" ||
    type === "Option" ||
    type === "date"
  ) {
    return "";
  } else if (type === "MultiSelect") {
    return [];
  } else if (type === "File" || type === "Image") {
    return "";
  } else if (type === "Checkbox") {
    return false;
  } else if (type === "Select") {
    return null;
  } else {
    return "";
  }
};

const typeOfIndustry = [
  { name: "Service" },
  { name: "Commercial" },
  { name: "Dealer" },
  { name: "Distributor" },
  { name: "Other" },
];

const CreateClientDetails = () => {
  const navigate = useNavigate();
  const [leadTemplate, setLeadTemplate] = useState([]);
  const [templateMaterId, settemplateMaterId] = useState(null);
  const [ClientStatusList, setClientStatusList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [stateID, setStateID] = useState();
  const [cityList, setCityList] = useState([]);
  const [showCompname, setShowCompamyName] = useState(
    JSON.parse(localStorage.getItem("CompanyIdSelect")) &&
      JSON.parse(localStorage.getItem("CompanyIdSelect")).CompanyName
  );

  const selectCompanyId =
    JSON.parse(localStorage.getItem("CompanyIdSelect")) &&
    JSON.parse(localStorage.getItem("CompanyIdSelect")).id;

  const {
    data: leadSource = {
      data: [],
    },
  } = useState();
  const { data: contactOwner = [] } = useState();

  // const OpenModalHandler = () => {
  //     setOpenModal(true)
  // }
  // const closeExcelImportModal=()=>{
  //     setOpenModal(true)
  // }

  const getTempalte = () => {
    const subTemplateTypeId = JSON.parse(localStorage.getItem("subTemplateId"));
    const companyId =
      JSON.parse(localStorage.getItem("CompanyIdSelect")) &&
      JSON.parse(localStorage.getItem("CompanyIdSelect")).id;
    const siteId =
      JSON.parse(localStorage.getItem("CompanyIdSelect")) &&
      JSON.parse(localStorage.getItem("CompanyIdSelect"))?.site?.id;

    const data = {
      companyId: companyId && companyId ? companyId : null,
      siteId: siteId ? siteId : null,
      templateTypeId:
        window.location.pathname === "/CreateDynamiceForm/clentsDetails"
          ? 4
          : 2,
      subTemplateTypeId:
        window.location.pathname === "/CreateDynamiceForm/clentsDetails"
          ? subTemplateTypeId
          : null,
      isForExport:
        window.location.pathname === "/CreateDynamiceForm/clentsDetails"
          ? true
          : false,
    };

    dynamiceForm.fetchGetSaveTempalte(data).then((response) => {
      if (response !== null) {
        setLeadTemplate(JSON.parse(response.data.templateData));
        // console.log(JSON.parse(response.data.templateData), "jkyfgeuy")
        settemplateMaterId(response.data.id);
      }
    });
  };

  const fetchcompanyclientstatusDataList = () => {
    const companyId =
      JSON.parse(localStorage.getItem("CompanyIdSelect")) &&
      JSON.parse(localStorage.getItem("CompanyIdSelect")).id;
    const data = {
      hrmsCompanyId: companyId && companyId ? companyId : null,
    };
    companyWiseEmp.fetchcompanyclientstatusmaster(data).then((response) => {
      if (response !== null) {
        setClientStatusList(response.data);

        if (response.responseCode === 404) {
          setClientStatusList([]);
          //alert("No record found Status List!!")
          // setClientStatusList(true)
        }
      } else {
        setClientStatusList([]);
      }
    });
  };
  const fetcStatausList = () => {
    dynamiceForm.fetchGetStateList().then((response) => {
      if (response !== null) {
        setStateList(response.data);
      }
    });
  };

  const fetcCityList = () => {
    const data = {
      cityId: stateID,
    };

    dynamiceForm.fetchGetCityList(data).then((response) => {
      if (response !== null) {
        setCityList(response.data);
      }
    });
  };
  const [addLead, response] = useState();
  //   const defaultColor = useSelector((state) => state.ColorSlice.value);
  const [formData, setFormData] = React.useState([]);

  const getFormData = React.useCallback(() => {
    const formDataToSet = [];
    leadTemplate &&
      leadTemplate.forEach((preview) => {
        console.log(preview.children.column2, "djbjhwbddv");
        preview.children.column1.forEach((child) => {
          // formDataToSet[child.name]=getInputDefaultVal(child.compName);
          formDataToSet.push({
            label: child.label,
            value: getInputDefaultVal(child.compName),
            name: child.name,
            mandetoryName: child.mandetoryName,
          });
        });
        preview.children.column2.forEach((child) => {
          // formDataToSet[child.name]=getInputDefaultVal(child.compName);
          formDataToSet.push({
            label: child.label,
            value: getInputDefaultVal(child.compName),
            name: child.name,
            mandetoryName: child.mandetoryName,
            isHidden: child.isHidden,
          });
        });
      });
    // setPreviews(previewData);
    console.log(formDataToSet, "formDataToSet");
    setFormData(formDataToSet);
  }, [leadTemplate]);

  const handleChange = (e, type, name) => {
    if (type === "MultiSelect") {
      // setFormData((prevData)=>{return {...prevData, [name]: e}});
      const formDataToSet = formData.map((item) => {
        if (item.name === name) {
          item.value = e;
        }
        return item;
      });
      setFormData(formDataToSet);
    } else if (type === "Checkbox") {
      //  setFormData((prevData)=>{return {...prevData, [e.target.name]: e.target.checked}});
      const formDataToSet = formData.map((item) => {
        if (item.name === name) {
          item.value = e.target.checked;
        }
        return item;
      });
      setFormData(formDataToSet);
    } else if (type === "Select") {
      const formDataToSet = formData.map((item) => {
        if (item.name === name) {
          item.value = e;
        }
        return item;
      });
      setFormData(formDataToSet);
    } else {
      //  setFormData((prevData)=>{return {...prevData, [e.target.name]: e.target.value}})

      const formDataToSet = formData.map((item) => {
        if (item.name === name) {
          item.value = e.target.value;
        }
        return item;
      });
      console.log(formDataToSet, "formDataToSet");
      setFormData(formDataToSet);
    }

    let state = 0;
    formData.forEach((item) => {
      if (item.mandetoryName === "State") {
        state = item.value;
      }
    });
    stateList.forEach((item) => {
      if (item.name === state) {
        setStateID(item.id);
        return;
      }
    });
  };

  const [latitude, setLatitude] = useState();
  const [longitude, setlongitude] = useState();
  //let latitude={lat:null,long:null}

  const getCurrentLocation = () => {
    navigator.geolocation.getCurrentPosition(
      (position) => (
        setLatitude(position.coords.latitude),
        setlongitude(position.coords.longitude)
      )
      //    lat: position.coords.latitude,
      //    lng: position.coords.longitude

      // position => setlongitude(
      //      position.coords.longitude
      // ),
      // err => console.log(err,"fjagug")
    );
    // console.log(navigator.geolocation.getCurrentPosition(),"svhwuwefueqr")
  };
  console.log(latitude, longitude, "sdvhvhfh");

  const meetingAddData = (event) => {
    // event.preventDefault();
    let Modeofcommunication = "";
    let ContactPerson = "";
    let PlcaeOfVisit = 0;
    let visitingCard = "";
    let leadSourceName = "";
    let ClientStatus = null;
    let phoneNo = "";
    let ReasonOfVisit = null;
    let discussionSummary = "";
    let remarks = "";
    let scheduleEndDate = "";
    let scheduleStartDate = "";
    let followupRemarks = "";
    formData.forEach((item) => {
      if (item.mandetoryName === "Modeofcommunication") {
        Modeofcommunication = item.value;
      } else if (item.mandetoryName === "visitingCard") {
        visitingCard = item.value;
      } else if (item.mandetoryName === "ClientStatus") {
        ClientStatus = item.value;
      } else if (item.mandetoryName === "phoneNo") {
        phoneNo = item.value;
      } else if (item.mandetoryName === "PlcaeOfVisit") {
        PlcaeOfVisit = item.value;
      } else if (item.mandetoryName === "ContactPerson") {
        ContactPerson = item.value;
      } else if (item.mandetoryName === "ReasonOfVisit") {
        ReasonOfVisit = item.value;
      } else if (item.mandetoryName === "discussionSummary") {
        discussionSummary = item.value;
      } else if (item.mandetoryName === "remarks") {
        remarks = item.value;
      } else if (item.mandetoryName === "scheduleStartDate") {
        scheduleStartDate = item.value;
      } else if (item.mandetoryName === "scheduleEndDate") {
        scheduleEndDate = item.value;
      }
    });

    const payload = {
      ContactPerson,
      PlcaeOfVisit,
      leadObjectData: formData,
      visitingCard,
      leadSourceName,
      phoneNo,
      templateMasterId: leadTemplate.id,
      ClientStatus,
      ReasonOfVisit,
      discussionSummary,
      remarks,
      scheduleStartDate,
      scheduleEndDate,
      followupRemarks,
    };
    console.log(payload, "jdgweufg");
    //addLead(payload);
  };

  const clientsAddData = (event) => {
    //event.preventDefault();
    getTempalte();
    let name = "";
    let contactPerson = "";
    let contactNo = "";
    let designation = "";
    let typeOfIndustry = null;
    let pinCode = "";
    let city = "";
    let address = "";
    let state = "";
    let cityId = null;
    let stateId = "";
    let panCardNumber = "";
    let gstNumber = "";
    let latitude = "";
    let longitude = "";
    let website = "";
    let remark = "";
    let term_condition = "ABcsdrgg";
    let emailId = "";
    let clientUpdatedStatusName = "";
    let clientUpdatedStatusId = null;

    formData.forEach((item) => {
      if (item.mandetoryName === "companyName") {
        name = item.value;
      } else if (item.mandetoryName === "ContactPerson") {
        contactPerson = item.value;
      } else if (item.mandetoryName === "phoneNo") {
        contactNo = item.value;
      } else if (item.mandetoryName === "designation") {
        designation = item.value;
      } else if (item.mandetoryName === "type") {
        typeOfIndustry = item.value;
      } else if (item.mandetoryName === "ClientStatus") {
        clientUpdatedStatusName = item.value;
      } else if (item.mandetoryName === "Address") {
        address = item.value;
      } else if (item.mandetoryName === "City") {
        city = item.value;
      } else if (item.mandetoryName === "State") {
        state = item.value;
      } else if (item.mandetoryName === "panno") {
        panCardNumber = item.value;
      } else if (item.mandetoryName === "gstno") {
        gstNumber = item.value;
      } else if (item.mandetoryName === "GPSAddress") {
        latitude = item.value;
      } else if (item.mandetoryName === "website") {
        website = item.value;
      } else if (item.mandetoryName === "email") {
        emailId = item.value;
      } else if (item.mandetoryName === "remarks") {
        remark = item.value;
      }
    });
    ClientStatusList &&
      ClientStatusList.forEach((item) => {
        if (item.statusName === clientUpdatedStatusName) {
          clientUpdatedStatusId = item.id;
          return;
        }
      });

    stateList &&
      stateList.forEach((item) => {
        if (item.name === state) {
          stateId = item.id;
          setStateID(item.id);
          return;
        }
      });
    cityList &&
      cityList.forEach((item) => {
        if (item.name === city) {
          cityId = item.id;
          return;
        }
      });

    if (name === "") {
      alert("Please Enter Your Company Name ");
      return false;
    } else if (contactPerson == "") {
      alert("Please Enter Your Contact Person Name ");
      return false;
    } else if (contactNo == "") {
      alert("Please Enter Your contactNo ");
      return false;
    } else if (designation == "") {
      alert("Please Enter Your Designation ");
      return false;
    }

    const payload = {
      hrmsCompanyId:
        JSON.parse(localStorage.getItem("CompanyIdSelect")) &&
        JSON.parse(localStorage.getItem("CompanyIdSelect")).id,
      name,
      contactPerson,
      contactNo,
      designation,
      typeOfIndustry,
      pinCode,
      city,
      address,
      state,
      cityId,
      stateId,
      panCardNumber,
      gstNumber,
      website,
      remark,
      term_condition,
      emailId,
      clientUpdatedStatusId,
      formData: formData,
      userId: JSON.parse(localStorage.getItem("data")).id,
      //  token:"68CEA962-D037-4C4F-B5F2-A9242E5625F6",
      //  latLong:"28.5030312,77.0868535",
      //  userCurrentLatitude:"28.5030312",
      //  userCurrentLongitude:"77.0868535",
      //  mode:1,
      templateMasterId:
        templateMaterId && templateMaterId !== null ? templateMaterId : null,
    };

    dynamiceForm.fetchCreateComunaction(payload).then((response) => {
      if (response !== null) {
        alert(response.responseDescription);
      } else {
        console.log("error");
      }
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (window.location.pathname === "/CreateDynamiceForm/clentsDetails") {
      clientsAddData();
    } else if (
      window.location.pathname === "/CreateDynamiceForm/MettingDetails"
    ) {
      meetingAddData();
    }
  };
  const gobackMainpage = () => {
    localStorage.removeItem("CompanyIdSelect");
    navigate("/companywiseclient");
  };

  const showResponse = () => {
    // if (response.status === "fulfilled" && isSuccess) {
    //   alert("Lead Added Successfully");
    //   navigate("/leadlist");
    // } else if (response.status === "rejected") {
    //   const message = response.error?.data?.message || "Lead Add Failed";
    //   alert(message);
    // }
  };
  useEffect(() => {
    if (stateID !== undefined) {
      fetcCityList();
    }
  }, [stateID]);

  React.useEffect(() => {
    showResponse();
  }, [response]);

  React.useEffect(() => {
    getTempalte();
    fetchcompanyclientstatusDataList();
    fetcStatausList();
  }, []);
  useEffect(() => {
    getFormData();
  }, [leadTemplate]);

  const url = window.location.pathname.split("/CreateDynamiceForm");

  const openEditlyoute = () => {
    navigate(`/customeForm${url[1]}`, "_self");
    // localStorage.setItem("leadTemplate", JSON.stringify(leadTemplate));
  };

  const topViewNavData = {
    title:
      window.location.pathname === "/CreateDynamiceForm/MettingDetails"
        ? "Add Meeting Details"
        : "Add Client Details",
    backPathRoute: "/dashboard",
    CompanyName: showCompname && showCompname,
  };

  return (
    <div className="contents__root">
      <Box className="main">
        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              alignItems: "end",
              justifyContent: "space-between",
              marginRight: "15px",
            }}
          >
            <TopViewNav topViewNavData={topViewNavData} />

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
              }}
            >
              <Box>
                <div className="field_box">
                  <div
                    className="field_box_btn1"
                    onClick={openEditlyoute}
                    style={{
                      cursor: "pointer",
                      padding: "8px",
                    }}
                  >
                    Edit Layout
                  </div>
                </div>
              </Box>

              {/* <Box  >
                                <div className="field_box">
                                    <div
                                        className="field_box_btn1"
                                        onClick={OpenModalHandler}
                                        style={{
                                            cursor: "pointer",
                                            padding: "8px"

                                        }}
                                    >
                                        Import Excel
                                    </div>

                                </div>
                            </Box> */}
            </div>
          </Box>
        </Grid>
        {/* <ImportExcel openModal={openModal} setOpenModal={setOpenModal} closeExcelImportModal={closeExcelImportModal} /> */}

        {/* form */}
        {/* <Box className='CompanyBox' onClick={openEditlyoute}>
                    <Link
                        to="/customeForm"
                        style={{
                            color: "blue",
                            textDecoration: "underline",
                        }}
                    >
                        Edit Layout
                    </Link>
                </Box> */}

        {/* <Box className='CompanyBox' onClick={getCurrentLocation}>
                    <Button
                    // to="/customeForm"
                    // style={{
                    //     color: "blue",
                    //     textDecoration: "underline",
                    // }}
                    >
                        Get Current Location
                    </Button>
                </Box> */}

        <Box
          component="form"
          sx={{
            "& .MuiTextField-root": { m: 1 },
            marginTop: "20px",
          }}
          className="CompanyBox"
        >
          {leadTemplate &&
            leadTemplate.map(({ layoutName, id, children }, index) => {
              console.log(layoutName, id, children, "dhvwehdefqw");

              console.log(layoutName, id, children, "cjsdbcjhbd");
              return (
                <Accordion
                  className="main_accoardian"
                  defaultExpanded={true}
                  key={index}
                >
                  <AccordionSummary
                    className="accordianHeader"
                    expandIcon={
                      <AddCircleIcon
                        fontSize="large"
                        style={{ color: "white" }}
                      />
                    }
                    aria-controls="panel1a-content"
                    style={{
                      background: "rgb(10 166 141)",
                      borderRadius: "10px 10px 0px 0px",
                      overflow: "hidden",
                    }}
                  >
                    <Typography
                      style={{
                        color: "#fff",
                        marginLeft: "10px",
                        padding: "10px 2px",
                      }}
                    >
                      {layoutName}
                    </Typography>
                  </AccordionSummary>

                  <AccordionDetails
                    className="accoardian_body"
                    style={{ width: "98%", margin: "auto", marginTop: "10px" }}
                  >
                    <Grid container spacing={2} className="CompanyMainBox">
                      <Grid item xs={6}>
                        {children.column1.map(
                          (
                            {
                              id,
                              name,
                              inputType,
                              compName,
                              label,
                              options,
                              uid,
                              isRequired,
                              isHidden,
                              mandetoryName,
                            },
                            index
                          ) => {
                            console.log(
                              id,

                              label,
                              "6536354635434bh"
                            );
                            return (
                              <React.Fragment key={uid}>
                                {!isHidden ? (
                                  <InputComps
                                    name={name}
                                    compName={compName}
                                    label={label}
                                    optionss={options}
                                    uid={uid}
                                    formData={formData}
                                    handleChange={handleChange}
                                    isRequired={isRequired}
                                    leadSource={leadSource.data}
                                    ClientStatusList={ClientStatusList}
                                    typeOfIndustry={typeOfIndustry}
                                    stateList={stateList}
                                    cityList={cityList}
                                    mandetoryName={mandetoryName}
                                    contactOwner={contactOwner}
                                  />
                                ) : null}
                              </React.Fragment>
                            );
                          }
                        )}
                      </Grid>
                      <Grid item xs={6}>
                        {children.column2.map(
                          (
                            {
                              id,
                              name,
                              inputType,
                              compName,
                              label,
                              options,
                              uid,
                              isRequired,
                              isHidden,
                              mandetoryName,
                            },
                            index
                          ) => {
                            return (
                              <React.Fragment key={uid}>
                                {!isHidden ? (
                                  <InputComps
                                    name={name}
                                    compName={compName}
                                    label={label}
                                    optionss={options}
                                    uid={uid}
                                    formData={formData}
                                    handleChange={handleChange}
                                    isRequired={isRequired}
                                    leadSource={leadSource.data}
                                    typeOfIndustry={typeOfIndustry}
                                    ClientStatusList={ClientStatusList}
                                    stateList={stateList}
                                    cityList={cityList}
                                    mandetoryName={mandetoryName}
                                    contactOwner={contactOwner}
                                  />
                                ) : null}
                              </React.Fragment>
                            );
                          }
                        )}
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              );
              //   })
              // }
            })}
          {/* buttons grid */}
          {/* <Grid container>
                        <Grid item xs={12}>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "flex-end",
                                    gap: "10px",
                                }}
                            >
                                <Button
                                    sx={{ background: "red", color: "#fff" }}
                                    onClick={() => navigate("/companywiseclient")}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    sx={{ background: "green", color: "#fff" }}
                                    variant="button"
                                    type="submit"
                                    onClick={handleSubmit}
                                >
                                    Add
                                </Button>
                            </Box>
                        </Grid>
                    </Grid> */}
          <Grid item xs={12}>
            <Grid
              style={{
                placeItems: "center",
                display: "flex",
                gap: "10px",
                justifyContent: "flex-end",
                padding: "10px 0",
              }}
            >
              <div className="field_box">
                <div
                  className="field_box_btn1"
                  onClick={() => gobackMainpage()}
                  style={{
                    cursor: "pointer",
                    padding: "10px",
                  }}
                >
                  Cancel
                </div>
              </div>
              <div className="field_box">
                <div
                  className="field_box_btn1"
                  onClick={handleSubmit}
                  style={{
                    cursor: "pointer",
                    padding: "10px",
                  }}
                >
                  Save
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </div>
  );
};

function InputComps({
  uid,
  label,
  name,
  compName,
  optionss,
  formData,
  handleChange,
  isRequired,
  typeOfIndustry,
  ClientStatusList,
  stateList,
  cityList,
  mandetoryName,
}) {
  let options = optionss;
  console.log(ClientStatusList, "optionssjfeurg");
  if (mandetoryName === "State") {
    options = stateList.map((source) => source.name);
  } else if (mandetoryName === "type") {
    options = typeOfIndustry && typeOfIndustry.map((owner) => `${owner.name}`);
  } else if (mandetoryName === "ClientStatus") {
    options =
      ClientStatusList &&
      ClientStatusList.map((owner) => `${owner && owner.statusName}`);
  } else if (mandetoryName === "City") {
    options = cityList && cityList.map((owner) => `${owner.name}`);
  }

  // const[selected, setSelected] = useState([]);
  console.log(compName, "compname");
  let currVal = "";
  console.log(currVal, "jfbfeqfdcfyu");
  formData.forEach((item) => {
    if (item.label === label) {
      currVal = item.value;
    }
  });
  const multiSelectOptions = [];
  if (options && compName === "MultiSelect") {
    options.forEach((option) => {
      multiSelectOptions.push({
        label: option,
        value: option,
      });
    });
  }
  const renderInputs = () => {
    if (compName === "Text") {
      return (
        <div className="form-group" key={uid}>
          <label htmlFor={name}>{label}</label>
          <CustomInputField
            sx={{ width: "100%", margin: "0px !important" }}
            variant="outlined"
            size="small"
            type="text"
            className="form-control"
            id={name}
            placeholder={label}
            name={name}
            value={currVal}
            onChange={(e) => handleChange(e, compName, name)}
            required={isRequired}
          />
        </div>
      );
    } else if (compName === "Date" || compName === "date") {
      return (
        <div className="form-group" key={uid}>
          <label htmlFor={name}>{label}</label>
          <CustomInputField
            sx={{ width: "100%", margin: "0px !important" }}
            variant="outlined"
            size="small"
            type="date"
            className="form-control"
            id={name}
            placeholder={label}
            name={name}
            value={moment(currVal).format("YYYY-DD-MM")}
            onChange={(e) => handleChange(e, compName, name)}
            required={isRequired}
          />
        </div>
      );
    } else if (compName === "TextArea") {
      return (
        <div className="form-group shadow-textarea" key={uid}>
          <label htmlFor={name}>{label}</label>
          <CustomTextArea
            multiline
            style={{ resize: "none" }}
            maxRows={5}
            sx={{ width: "100%", margin: "0px !important" }}
            className="form-control z-depth-1"
            id={name}
            placeholder={label}
            name={name}
            value={currVal}
            onChange={(e) => handleChange(e, compName, name)}
            required={isRequired}
          />
        </div>
      );
    } else if (compName === "image" || compName === "File") {
      return (
        <div lassName="form-group" key={uid}>
          <label htmlFor={name}>{label}</label>
          <CustomInputField
            type="file"
            sx={{ width: "100%", margin: "0px !important" }}
            className="form-control"
            id={name}
            placeholder={label}
            name={name}
            value={currVal}
            onChange={(e) => handleChange(e, compName, name)}
            required={isRequired}
          />
        </div>
      );
    } else if (compName === "Option") {
      return (
        <div className="form-group" key={uid} style={{ margin: "7px 0px" }}>
          <label htmlFor={name}>{label}</label>
          <div
            onChange={(e) => handleChange(e, compName, name)}
            style={{
              display: "flex",
              gap: "10px",
              flexWrap: "wrap",
              padding: "8px 6px",
              background: "#EFF0F2",
              borderRadius: "8px",
              borderLeft: isRequired
                ? "2px solid red"
                : "2px solid transparent",
            }}
          >
            {options.map((option, index) => {
              return (
                <div className="form-check" key={option}>
                  <input
                    className="form-check-input"
                    type="radio"
                    name={name}
                    id={name}
                    value={option}
                  />

                  <label
                    className="form-check-label"
                    htmlFor="flexRadioDefault1"
                  >
                    {option}
                  </label>
                </div>
              );
            })}
          </div>
        </div>
      );
    } else if (compName === "Email") {
      return (
        <div className="form-group" key={uid}>
          <label htmlFor={name}>{label}</label>
          <CustomInputField
            sx={{ width: "100%", margin: "0px !important" }}
            type="email"
            className="form-control"
            id={name}
            placeholder={label}
            name={name}
            value={currVal}
            onChange={(e) => handleChange(e, compName, name)}
            variant="outlined"
            required={isRequired}
          />
        </div>
      );
    } else if (compName === "Checkbox") {
      return (
        <div className="form-group">
          <label htmlFor={name}>{label}</label>
          <div
            sx={{ width: "100%", margin: "0px !important", background: "red" }}
          >
            <CustomInputField
              sx={{
                ".MuiInputBase-root": {
                  borderRadius: "5px !important",
                  padding: "0px 4px",
                  borderLeft: isRequired
                    ? "2px solid red"
                    : "2px solid transparent",
                },
              }}
              className="form-check-input"
              type="checkbox"
              checked={currVal}
              id={name}
              name={name}
              required={isRequired}
              onChange={(e) => handleChange(e, compName, name)}
            />
          </div>
        </div>
      );
    } else if (compName === "MultiSelect") {
      return (
        <div className="form-group" key={uid}>
          <label htmlFor={name}>{label}</label>
          <MultiSelect
            options={multiSelectOptions}
            value={currVal}
            sx={{
              ".MuiInputBase-root": {
                borderRadius: "5px !important",
                borderLeft: isRequired
                  ? "2px solid red"
                  : "2px solid transparent",
              },
            }}
            // onChange={setSelected}
            onChange={(val) => handleChange(val, compName, name)}
            id={name}
          />
        </div>
      );
    } else if (compName === "Select") {
      return (
        <div className="form-group" key={uid}>
          <label htmlFor={name}>{label}</label>
          <CustomAutoComplete
            id={name}
            options={options}
            sx={{
              ".MuiInputBase-root": {
                borderRadius: "5px !important",
                borderLeft: isRequired
                  ? "2px solid red"
                  : "2px solid transparent",
              },
            }}
            value={currVal}
            onChange={(e, newVal) => handleChange(newVal, compName, name)}
            renderInput={(params) => (
              <CustomInputField {...params} placeholder={label} />
            )}
          />
        </div>
      );
    } else {
      return <>{label}</>;
    }
  };
  return <React.Fragment>{renderInputs()}</React.Fragment>;
}

export default CreateClientDetails;
